module.exports = __webpack_public_path__ + "media/site_templates/www.exterminators.net.au/images/splash-b8d2cb46a9712bb436f706547c92d54b.jpg";